function doRotatingBanner() {
  if (customElements.get("rotating-banner")) return null

  class RotatingBanner extends HTMLElement {
    constructor() {
      super()
      this.sliderElement = this.querySelector(".rotating-banner-wrapper")
      this.sliderScrollTimer = this.dataset.bannerScrollTimer
      this.init()
    }
    init() {
      this.executeSwiper()
    }

    executeSwiper() {
      if (this.sliderElement == null) return
      const delayTimer = this.isStringNumber(this.sliderScrollTimer) ?? 5
      const delay = delayTimer * 1000
      const swiper = new Swiper(this.sliderElement, {
        direction: "horizontal",
        loop: true,
        centeredSlides: true,
        speed: delay,
        slidesPerView: "auto",
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
      })
    }
    isStringNumber(str) {
      if (!str) return false
      const number = parseFloat(str)
      return !isNaN(number) ? number : false
    }
  }
  customElements.define("rotating-banner", RotatingBanner)
}
doRotatingBanner()
